import { Link } from "react-router-dom";

const TermsPage = () => {
  return (
    <div className="min-h-screen bg-warm-white pt-24">
      <section className="py-12 md:py-20">
        <div className="max-w-3xl mx-auto px-5 sm:px-6 md:px-12">
          <h1 className="font-heading text-3xl sm:text-4xl md:text-5xl font-medium text-plum mb-4">
            Terms of Service
          </h1>
          <p className="font-body text-plum/60 mb-10">Last updated: June 2026</p>

          <div className="space-y-8 font-body text-plum/80 leading-relaxed">
            <div>
              <h2 className="font-heading text-xl md:text-2xl text-plum mb-3">1. Overview</h2>
              <p>
                These Terms of Service ("Terms") govern your use of the People's Medicine website and doula support services operated by Trina Cobbler ("People's Medicine," "we," "us," or "our"). By accessing our website or booking any services, you agree to be bound by these Terms.
              </p>
            </div>

            <div>
              <h2 className="font-heading text-xl md:text-2xl text-plum mb-3">2. Services</h2>
              <p>
                People's Medicine provides non-medical doula support services including but not limited to: Doula Direct™ virtual and phone consultations, birth doula support, postpartum doula support, childbirth education, family support services, and the 10-Visit Support Package. Our services are informational and supportive in nature. We do not provide medical advice, diagnosis, or treatment.
              </p>
            </div>

            <div>
              <h2 className="font-heading text-xl md:text-2xl text-plum mb-3">3. Not Medical Advice</h2>
              <p>
                The information and support provided by People's Medicine is not a substitute for professional medical advice, diagnosis, or treatment. Always seek the advice of your physician, midwife, or other qualified health provider with any questions you may have regarding a medical condition. Never disregard professional medical advice or delay in seeking it because of information received through our services.
              </p>
            </div>

            <div>
              <h2 className="font-heading text-xl md:text-2xl text-plum mb-3">4. Booking and Payment</h2>
              <p>
                Services are booked through our online scheduling system. Payment terms vary by service. By booking a session, you agree to the pricing disclosed at the time of booking. Cancellations must be made at least 24 hours in advance for a full refund. Cancellations made with less than 24 hours notice may be subject to a cancellation fee.
              </p>
            </div>

            <div>
              <h2 className="font-heading text-xl md:text-2xl text-plum mb-3">5. Insurance</h2>
              <p>
                We accept select insurance plans including CareFirst BlueCross BlueShield and UnitedHealthcare (Commercial and Community plans). Coverage varies by plan. It is your responsibility to verify your specific plan coverage prior to booking services. We are not responsible for claims denied by your insurance provider.
              </p>
            </div>

            <div>
              <h2 className="font-heading text-xl md:text-2xl text-plum mb-3">6. Virtual Services</h2>
              <p>
                Virtual and phone services are conducted via Zoom or telephone. You are responsible for ensuring a stable internet or phone connection for your sessions. People's Medicine is not responsible for technical issues on your end that may affect the quality of the session.
              </p>
            </div>

            <div>
              <h2 className="font-heading text-xl md:text-2xl text-plum mb-3">7. Confidentiality</h2>
              <p>
                We respect the privacy of our clients. Information shared during sessions is kept confidential except where required by law or where there is a concern for the safety of the client, their children, or others.
              </p>
            </div>

            <div>
              <h2 className="font-heading text-xl md:text-2xl text-plum mb-3">8. Limitation of Liability</h2>
              <p>
                People's Medicine and its representatives shall not be held liable for any adverse outcomes related to pregnancy, birth, postpartum recovery, or newborn care. Our services are supportive and educational in nature. By using our services, you acknowledge that all decisions regarding your medical care remain your own.
              </p>
            </div>

            <div>
              <h2 className="font-heading text-xl md:text-2xl text-plum mb-3">9. Intellectual Property</h2>
              <p>
                All content on this website, including text, images, logos, and the Doula Direct™ name and branding, are the property of People's Medicine and are protected by applicable intellectual property laws. You may not reproduce, distribute, or use any content without prior written consent.
              </p>
            </div>

            <div>
              <h2 className="font-heading text-xl md:text-2xl text-plum mb-3">10. Changes to Terms</h2>
              <p>
                We reserve the right to update these Terms at any time. Changes will be posted on this page with an updated date. Continued use of our website or services after changes constitutes acceptance of the revised Terms.
              </p>
            </div>

            <div>
              <h2 className="font-heading text-xl md:text-2xl text-plum mb-3">11. Contact</h2>
              <p>
                If you have questions about these Terms, please contact us at (856) 567-5907 or through our <a href="https://trina-cobbler.clientsecure.me/contact-widget" target="_blank" rel="noopener noreferrer" className="text-teal hover:underline">client portal</a>.
              </p>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-peach/50">
            <Link to="/" className="font-body text-teal hover:underline">&larr; Back to Home</Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TermsPage;
